<template>
    <span>
        <introduction></introduction>
        <date-selector></date-selector>
        <visualization-old></visualization-old>
        <visualization-line></visualization-line>
        <visualization-line-bauer></visualization-line-bauer>
        <visualization-line-neg></visualization-line-neg>
        <bottom-information></bottom-information>
        <footSection></footSection>
    </span>
</template>

<script>
import Introduction from "@/components/Introduction";
import DateSelector from "@/components/DateSelector";
import VisualizationOld from "@/components/VisualizationOld";
import VisualizationLine from "@/components/VisualizationLine";
import VisualizationLineBauer from "@/components/VisualizationLineBauer";
import VisualizationLineNeg from "@/components/VisualizationLineNeg";
import BottomInformation from "@/components/BottomInformation"
import FootSection from "@/components/FootSection";

export default {
    name: "home",
    components: {
        Introduction,
        DateSelector,
        VisualizationOld,
        VisualizationLine,
        VisualizationLineBauer,
        VisualizationLineNeg,
        BottomInformation,
        FootSection
    },
};
</script>
